import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import Profile from './Profile';
import Dashboard from './Dashboard';
import OnboardingRequestForm from './Component/OnboardingRequestForm';
import SearchOnboardingForm from './Component/SearchOnboardingForm';
import SearchResult from './Component/SearchResult';
import SideNavBar from './Container/Common/SideNavBar';
import { getUserDetails } from './Constants';
import UserContextProvider from './UserContextProvider';
import Header from './Container/Common/Header';
import OktaDebugInfo from './components/OktaDebugInfo';

// Custom SecureRoute component for React Router v6
const SecureRoute = ({ children }) => {
    const { authState, oktaAuth } = useOktaAuth();

    //console.log('SecureRoute - authState:', authState);

    if (!authState) {
        return <div>Loading authentication...</div>;
    }

    if (!authState.isAuthenticated) {
        console.log('User not authenticated, triggering sign in...');
        oktaAuth.signInWithRedirect({
            originalUri: window.location.pathname
        });
        return <div>Redirecting to login...</div>;
    }

    return children;
};

const Routers = () => {
    const {authState } = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const [userType, setUserType] = useState("")
    
    useEffect(() => {
      setUserInfo(getUserDetails(authState)) 
    },[authState])

  useEffect(() => {
    if(userInfo !== null){
        if(userInfo.email.endsWith("@juniper.net")) setUserType("I")
        else setUserType("E")
    }
    },[userInfo])

    const onBoardingFormComponent = () => {
        return(
            <>
            <Header></Header>
            <main className='main-page'>
                <SideNavBar />
                <OnboardingRequestForm />
            </main>
            </>
        )
    }
    const intialComponent = () => {
        return(
            <>
            <Header></Header>
            <main className='main-page'>
                {userType === "I" && <>
                <SideNavBar />
                <Dashboard />
                </>}
                {userType === "E" && <OnboardingRequestForm />}
            </main>
            </>
        )
    }
    const searchOnboardingFormComponent = () => {
        return(
            <>
            <Header></Header>
            <main className='main-page'>
                <SideNavBar />
                <SearchOnboardingForm />
            </main>
            </>
        )
    }
    const searchResultComponent = () => {
        return(
            <>
            <Header></Header>
            <main className='main-page'>
                <SideNavBar />
                <SearchResult />
            </main>
            </>
        )
    }
    return (
        <UserContextProvider>
            <Routes>
                <Route path="/onboardingRequestForm" element={
                    <SecureRoute>
                        {onBoardingFormComponent()}
                    </SecureRoute>
                } />
                <Route path="/" element={
                    <SecureRoute>
                        {intialComponent()}
                    </SecureRoute>
                } />
                <Route path="/search" element={
                    <SecureRoute>
                        {searchOnboardingFormComponent()}
                    </SecureRoute>
                } />
                <Route path="/profile" element={
                    <SecureRoute>
                        <Header />
                        <main className='main-page'>
                            <SideNavBar />
                            <Profile />
                        </main>
                    </SecureRoute>
                } />
                <Route path="/dashboard" element={
                    <SecureRoute>
                        <Header />
                        <main className='main-page'>
                            <SideNavBar />
                            <Dashboard />
                        </main>
                    </SecureRoute>
                } />
                <Route path="/searchResult" element={
                    <SecureRoute>
                        {searchResultComponent()}
                    </SecureRoute>
                } />
            </Routes>
            <OktaDebugInfo />
        </UserContextProvider>
    );
};

export default Routers;